import React from 'react'

import OrdersPage from '../Orders/OrdersPage'
const Quote = props => {
  return <OrdersPage {...props} />
}
export default Quote
